import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const switchboardConfig: TSPConfig = {
  key: 'switchboard',
  name: 'Switchboard',
  category: TSPCategory.CUSTOM,
  helpText: (
    <ol>
      <li>Login into your Switchboard account.</li>
      <li>Go to the "Settings" on the top right hand side of the window.</li>
      <li>At the bottom of the page, create a new API key and ID.</li>
      <li>
        Copy the API key and ID, as well as the username and password you use to
        sign into Switchboard here.
      </li>
    </ol>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'API ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
        {
          label: 'API Key',
          name: 'apikey',
          type: 'text',
          required: true,
        },
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default switchboardConfig;
